import React, { useEffect } from 'react';
import useTealium from '../../../../hooks/useTealium';
import { TEALIUM_PAGE_VIEW } from '../../../../constants/tealiumConstants';
import CommHelpStaticPageDisplayText from './language/CommHelpStaticPageDisplayText';
import useTranslate from 'src/hooks/useTranslate';
import { getEnvVariable } from 'src/utils/envUtils';
const CommHelpStaticPage = () => {
    const { trackView } = useTealium();
    const { t } = useTranslate();
    const smsFromNumber = getEnvVariable('smsFromNumber');
    useEffect(() => {
        trackView({
            page_l3: TEALIUM_PAGE_VIEW.PAGE_L3.COMM_HELP,
            page_l4: TEALIUM_PAGE_VIEW.PAGE_L4.COMM_HELP.VIEW,
        });
    }, []);
    return (<span>
      <header style={{ border: 'solid 2px black' }}>
         <div>
         <div style={{ backgroundColor: '#C9DAED', borderBottom: 'solid 2px black' }}>
            <div style={{ padding: '.5rem', textAlign: 'center' }}>
              <b>{t(CommHelpStaticPageDisplayText.programOverview)}</b>
            </div>
         </div>
         <div style={{ padding: '.5rem' }}>
           {t(CommHelpStaticPageDisplayText.programOverviewDescription)}
         </div>
         </div>
     </header>
     <p><b><br />{t(CommHelpStaticPageDisplayText.termsAndConditions)}<br /></b></p>
     <p>{t(CommHelpStaticPageDisplayText.mobileOperators)}</p>
     <ol>
       <li>{t(CommHelpStaticPageDisplayText.listEntry1).replace('{smsFromNumber}', smsFromNumber)}</li>
       <li>{t(CommHelpStaticPageDisplayText.listEntry2).replace('{smsFromNumber}', smsFromNumber)}</li>
       <li><b>{t(CommHelpStaticPageDisplayText.listEntry3)}</b></li>
       <li>{t(CommHelpStaticPageDisplayText.listEntry4)}</li>
       <li>{t(CommHelpStaticPageDisplayText.listEntry5)}</li>
       <li>{t(CommHelpStaticPageDisplayText.listEntry6)}</li>
       <li>{t(CommHelpStaticPageDisplayText.listEntry7)}</li>
       <li>{t(CommHelpStaticPageDisplayText.listEntry8)}</li>
       <li>{t(CommHelpStaticPageDisplayText.listEntry9)}</li>
       <li>{t(CommHelpStaticPageDisplayText.listEntry10)}</li>
       <li>{t(CommHelpStaticPageDisplayText.listEntry11)}</li>
       <li>
         {t(CommHelpStaticPageDisplayText.listEntry12)}
         <a target='_blank' href='https://www.lincolnfinancial.com/public/general/privacy'>
           <b>{t(CommHelpStaticPageDisplayText.listEntry12Link)}</b>
         </a>
       </li>
       <li>{t(CommHelpStaticPageDisplayText.listEntry13)}</li>
     </ol>
    </span>);
};
export default CommHelpStaticPage;
